import { render, staticRenderFns } from "./userAgreement_serviceHall.vue?vue&type=template&id=2cf29626"
import script from "./userAgreement_serviceHall.vue?vue&type=script&lang=js"
export * from "./userAgreement_serviceHall.vue?vue&type=script&lang=js"
import style0 from "./userAgreement_serviceHall.vue?vue&type=style&index=0&id=2cf29626&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports